import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';

import { daysFromNow } from '@zapier/date';
import { useIsAuthenticated } from '@zapier/design-system-revenue/src/hooks';

import { teamsDowngradedBannerQuery as TeamsDowngradedBannerQuery } from './types/teamsDowngradedBannerQuery';

export const teamsDowngradedBannerQuery = gql`
  query teamsDowngradedBannerQuery($accountId: Int!) {
    account(id: $accountId) {
      id
      isTeamAccount
      teamAccountEndDate
    }
  }
`;

export type Props = {
  skip?: boolean;
};

export const useShouldRender = ({ skip }: Props = {}) => {
  const { isAuthenticated } = useIsAuthenticated();

  const accountId = localStorage.getItem('currentAccountId');

  const { data } = useQuery<TeamsDowngradedBannerQuery>(
    teamsDowngradedBannerQuery,
    {
      skip: skip || !isAuthenticated || !accountId,
      variables: {
        accountId: parseInt(accountId ?? ''),
      },
    }
  );

  const account = data?.account;

  const daysSinceTeamDowngrade = account?.teamAccountEndDate
    ? daysFromNow(account?.teamAccountEndDate)
    : 0;

  return (
    !account?.isTeamAccount &&
    !!account?.teamAccountEndDate &&
    daysSinceTeamDowngrade <= 7
  );
};
